import React from "react";
import { roomTypeService } from "../jwt/_services/hotel/roomTypeService";

export const roomTypeProvider = {
    getOptions,
    getItem,
};

async function getOptions(customFilter) {
    try {
        const listItems = await roomTypeService.search(0, 1000, customFilter);
        return listItems.data.map((item) => {
            return (
                {
                    id: item.id,
                    value: item.codeSynxis + ' | ' + item.title,
                    label: <label>{item.codeSynxis.toUpperCase() + ' | '} <b>{item.title}</b> </label>
                }
            )
        });
    } catch (error) {
        console.log(error.message)
    }
}

async function getItem(id) {
    try {
        const item = await roomTypeService.getItem(id);

        return (
            {
                id: item.id,
                value: item.code,
                label: <div><label>{item.code}</label></div>
            }
        );
    } catch (error) {
        console.log(error.message)
    }
}